import UsersTable from "./UsersTable";

export default function Picker() {
  return <UsersTable type="picker" />;
}
